import { Fade, Stack, Typography } from "@mui/material";
import { AquariusBadge } from "@smartrr/shared/customerPortal/components/AquariusBadge";
import { getTotalDisplay } from "@smartrr/shared/utils/displayUtils";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import React from "react";

import { ISubManagementBadge } from "../../../types";

export const SubscriptionManagementCardBadges = ({
  showAllSubscriptions: inManageSubscriptionView,
  purchaseState,
  skdIdx,
  subscriptionStatus,
}: ISubManagementBadge) => {
  const { containsOOSItems, isError, isGifted, isPrepaid } = subscriptionStatus;

  const showErrorBadge = containsOOSItems || isError;

  return (
    <Stack
      direction="row"
      gap="3px"
      alignItems="center"
      justifyContent={showErrorBadge || isGifted ? "space-between" : "flex-end"}
      width="100%"
      data-testid="subscription-card-badges"
    >
      <Stack direction="row" gap="3px" alignItems="center">
        {showErrorBadge ? (
          <Fade in={showErrorBadge}>
            <div>
              <AquariusBadge icon="exclamationMark" label={typedLocalize("badgeStatus.importantNotice")} />
            </div>
          </Fade>
        ) : null}

        {isGifted ? (
          <Fade in={isGifted}>
            <div>
              <AquariusBadge icon="gift" label={typedLocalize("subscriptions.yourNextOrder.giftedLabel")} />
            </div>
          </Fade>
        ) : null}
      </Stack>
      {inManageSubscriptionView ? (
        <Fade in={inManageSubscriptionView}>
          <div>
            <AquariusBadge status={purchaseState.purchaseStateStatus} />
          </div>
        </Fade>
      ) : (
        <Fade in={!inManageSubscriptionView}>
          <Typography variant={"body1"}>
            {isPrepaid
              ? typedLocalize("general.prepaid")
              : getTotalDisplay(purchaseState.schedule.paymentFrequencyMultiple, purchaseState, skdIdx)}
          </Typography>
        </Fade>
      )}
    </Stack>
  );
};
